import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f6fa;
  height: 100vh;
  width: 100%;
`;
